export const DEFAULT_UNITS = [
  'Thùng',
  'Hộp',
  'Chai',
  'Lon',
  'Gói',
  'Túi',
  'Bịch',
  'Can',
  'kg',
  'g',
  'ml',
  'lít',
  'Ly',
  'Quả',
];

/**
 * Merge unique units from DB with standard F&B units
 */
export function getUniqueUnits(dbUnits: string[] = []): string[] {
  const set = new Set<string>();
  // Add DB units first
  dbUnits.filter(Boolean).forEach((u) => set.add(u.trim()));
  // Add common units
  DEFAULT_UNITS.forEach((u) => set.add(u));
  return Array.from(set);
}
